import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmationModal({
    show,
    onHide,
    title,
    content,
    onAcceptClick,
    onCancelClick,
    acceptText = 'Confirm',
    cancelText = 'Cancel',
    acceptVariant = 'primary',
    acceptDisabled = false,
    cancelDisabled = false,
    closeDisabled = false
}) {
    return (
        <Modal
            show={show}
            onHide={closeDisabled ? undefined : onHide}
            backdrop={closeDisabled ? 'static' : true}
            keyboard={!closeDisabled}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton={!closeDisabled}>
                <Modal.Title id="contained-modal-title-vcenter">
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {content}
            </Modal.Body>
            <Modal.Footer>
                <div className='w-100 d-flex justify-content-between'>
                    <Button variant='outline-dark' disabled={cancelDisabled} onClick={onCancelClick ?? onHide}>{cancelText}</Button>
                    <Button variant={acceptVariant} disabled={acceptDisabled} onClick={onAcceptClick ?? onHide}>{acceptText}</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;
